import React, { useState } from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col, CardText } from "reactstrap"
import SimpleBar from "simplebar-react"

//Import images
import avatar3 from "assets/images/users/avatar-1.jpg"
import avatar4 from "assets/images/users/avatar-1.jpg"

//i18n
import { withTranslation } from "react-i18next"

const NotificationDropdown = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon waves-effect"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="bx bx-bell bx-tada" />
          <span className="badge bg-danger rounded-pill">3</span>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg p-0 dropdown-menu-end">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0"> {props.t("Notifications")} </h6>
              </Col>
              <div className="col-auto">
                <a href="#!" className="small text-primary font-size-12">
                  {" "}
                  See All
                </a>
              </div>
            </Row>
          </div>

          <SimpleBar style={{ height: "230px" }}>
            <Link to="" className="text-reset notification-item">
              <div className="border p-3">
                <CardText tag="h6" className="font-font-size-18">Akram Magdy <span className="badge bg-light font-size-12 text-success">Admin</span></CardText>
                <CardText tag="p" className="text-muted mb-2">12 Mar, 2020</CardText>
                <CardText tag="p" className="text-muted">
                Added a new compound <span className="fw-bold text-decoration-underline text-dark">Prime Avenu</span> 
                </CardText>
              </div>
            </Link>
            <Link to="" className="text-reset notification-item">
              <div className="border p-3">
                <CardText tag="h6" className="font-font-size-18">Akram Magdy <span className="badge bg-light font-size-12 text-success">Admin</span></CardText>
                <CardText tag="p" className="text-muted mb-2">12 Mar, 2020</CardText>
                <CardText tag="p" className="text-muted">
                Added a new compound <span className="fw-bold text-decoration-underline text-dark">Prime Avenu</span> 
                </CardText>
              </div>
            </Link>
            <Link to="" className="text-reset notification-item">
              <div className="border p-3">
                <CardText tag="h6" className="font-font-size-18">Akram Magdy <span className="badge bg-light font-size-12 text-success">Admin</span></CardText>
                <CardText tag="p" className="text-muted mb-2">12 Mar, 2020</CardText>
                <CardText tag="p" className="text-muted">
                Added a new compound <span className="fw-bold text-decoration-underline text-dark">Prime Avenu</span> 
                </CardText>
              </div>
            </Link>
          </SimpleBar>
          <div className="p-2 border-top d-grid">
            <Link
              className="btn btn-sm btn-link font-size-14 btn-block text-center"
              to="#"
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>
              {" "}
              {props.t("View all")}{" "}
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

export default withTranslation()(NotificationDropdown)

NotificationDropdown.propTypes = {
  t: PropTypes.any
}